export default "__VITE_ASSET__C$19jkIy__"